import React from 'react';
import { Link } from 'react-router';
import { Helmet } from 'react-helmet';
import AppRoutes from '../../routes/routes';
import AuthRoutes from '../../routes/logged-in';
import Api from '../../api/api';
import AuthApi from '../../api/authApi';
import CONSTANTS from '../../constants/constants';
import { SERVER_ERROR, HELP_INFO } from '../../constants/messages';
import AuthMixin from '../../mixins/authenticationMixin';
import SettingsNotice from '../../components/notices/notice';
import Loading from '../../components/loading/loading';
import LoginActions from '../../actions/login-actions';
import './user-details.scss';
import '../../../css/design-system.scss';

class DeleteAccount extends React.Component {
  constructor(){
    super();
    this.messageRef = React.createRef();
    this.captchaRef = React.createRef();
    this.captcha = Api.captcha();
    this.state = {
      success: false,
      clientError: false,
      serverError: false,
      error_messages: [],
      loading: false
    };
  }

  validateInput(data){
    const error_messages = [];

    if(+data.captcha != this.captcha.result){
      error_messages.push("That answer isn't right, please try again");
    }

    if(Api.hasEmptyFields(data)){
      error_messages.push('Please fill in all fields');
    }

    return error_messages;
  }

  handleSubmit(e){
    e.preventDefault();

    this.setState({
      loading: true
    });

    const message = this.messageRef.current.value;
    const captcha = this.captchaRef.current.value;
    const data = { message, captcha};
    const error_messages = this.validateInput(data);

    if(error_messages.length){
     return this.setState({
        clientError: true,
        success: false,
        serverError: false,
        loading: false,
        error_messages
      });
    }

    this.setState({
      clientError: false,
      serverError: false
    });

    this.sendForm(data);
  }

  sendForm(data){
    AuthApi.deleteUserAccount(this.props.userApiRequest, data, {
      onSuccess: () => {
        this.setState({
          success: true,
          clientError: false,
          serverError: false,
          loading: false
        });

        setTimeout(() => LoginActions.logout(this.props.userApiRequest), 5000);
      },
      onError: () => {
        this.setState({
          serverError: true,
          success: false,
          clientError: false,
          loading: false
        });
      }
    });
  }

  renderNotice(){
    if (this.state.success) {
      return (
        <SettingsNotice type="success">
          Your account has been deleted. You'll be signed out in 5 seconds.
        </SettingsNotice>
      );
    }
    if (this.state.serverError) {
      return (
        <SettingsNotice type="error">
          {SERVER_ERROR} {HELP_INFO}
        </SettingsNotice>
      );
    }
    if (this.state.clientError) {
      const messages = this.state.error_messages;
      return (
        <SettingsNotice type="error">
          {messages.length === 1 ? messages[0] : <ul>{messages.map((message) => <li key={message}>{message}</li>)}</ul>}
        </SettingsNotice>
      );
    }
    return null;
  }

  render(){
    return (
      <div className="settings-modern-page">
        <Helmet>
          <title>Neurochecklists | Delete your account</title>
        </Helmet>

        <div className="settings-form-wrap">

          <div className="settings-page-header">
            <h1 className="section-title">Delete Your Account</h1>
            <p className="section-sub">We're sorry to see you go.</p>
          </div>

          {this.renderNotice()}

          {this.state.success ? null : (
            <React.Fragment>
              <div className="settings-copy">
                <p>If something wasn't working for you, our <a href={AppRoutes.faqs}>FAQs</a> may help, or email us at <a href={`mailto:${CONSTANTS.CONTACT_EMAIL}`}>{CONSTANTS.CONTACT_EMAIL}</a> and tell us how we can do better.</p>
              </div>

              <div className="settings-warning">
                <strong>This can't be undone.</strong> Your account, bookmarks and notes are deleted straight away, any subscription is cancelled, and you'll be signed out.
              </div>

              <form onSubmit={this.handleSubmit.bind(this)}>
                {(this.state.loading)? <Loading text="Please wait..." /> : null }

                <div className="input-group settings-input-row">
                  <label className="input-label" htmlFor="delete_reason">Why are you deleting your account?</label>
                  <textarea
                    ref={this.messageRef}
                    id="delete_reason"
                    className="input-field settings-textarea"
                    rows="5"
                    required
                  />
                </div>

                <div className="input-group settings-input-row">
                  <label className="input-label" htmlFor="delete_captcha">To confirm, what is {this.captcha.leftside} + {this.captcha.rightside}?</label>
                  <input
                    ref={this.captchaRef}
                    id="delete_captcha"
                    className="input-field"
                    type="text"
                    inputMode="numeric"
                    autoComplete="off"
                    required
                  />
                </div>

                <div className="settings-form-actions">
                  <Link to={AuthRoutes.account} className="settings-back-link">Back to your profile</Link>
                  <button type="submit" className="btn settings-danger-btn">Delete my account</button>
                </div>
              </form>
            </React.Fragment>
          )}
        </div>
      </div>
    )
  }
}

export default AuthMixin(DeleteAccount);
